import { skillCategories } from '@/data/skills';
import { Container, SectionHeading } from '@/components/common/SectionHeading';
import styles from './Skills.module.css';

export function Skills() {
  return (
    <section id="skills" className="section" aria-labelledby="skills-heading">
      <Container>
        <SectionHeading
          id="skills-heading"
          eyebrow="Skills"
          title="Technical skills"
          description="Technologies drawn from real project and role experience—grouped for clarity, without artificial proficiency scores."
        />
        <div className={styles.grid}>
          {skillCategories.map((category) => (
            <article key={category.id} className={styles.card}>
              <h3 className={styles.title}>{category.title}</h3>
              {category.description ? (
                <p className={styles.description}>{category.description}</p>
              ) : null}
              <ul className={styles.list}>
                {category.skills.map((skill) => (
                  <li key={skill}>{skill}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
